import React, { forwardRef, useRef } from 'react';
import styles from './FormSerieHistorica.module.scss';
import NomeIndicadorView from '../inputNomeIndicador/InputNomeIndicador';
import InputField from '../../../../../components/inputField/InputField';
import InputDropDown from '../../../../../core/components/inputs/inputDropDown/InputDropDown';
import { Fieldset } from 'primereact/fieldset';
import PageMessages from '../../../../../config/translations/PageMessages';
import Checkbutton from '../../../../../core/components/inputs/checkbutton/Checkbutton';
import { inputsSerieHistoricaTopo } from '../../PageInputs';
import BaseForm from '../../../../../core/page/components/baseForm/BaseForm';
import Pages from '../../../../../config/Pages';
import { InfoIcon } from '../../../../../components/rotuloSeplag/RotuloSeplag';
import { Tooltip } from 'primereact/tooltip';
import tipoCadastroPropostaService from '../../../../../service/TipoCadastroPropostaService';
import stylesDiff from '../Utils.module.scss';

function FormTopo({ isView, idIndicador, dadosIndicadorRef }, ref) {
    const tipoCadastroPropostaRef = useRef(null);

    const Inputs = ({ formik, formController }) => (
        <form className={`p-col-12 p-grid p-fluid ${styles.form}`}>
            <Tooltip target=".concordoComOsTermos" />
            <NomeIndicadorView disabled />
            <InputField
                formController={formController}
                formik={formik}
                id="tipoCadastroProposta"
                cols="12 4"
                className={`${styles.inputNovoIndicador} ${
                    idIndicador &&
                    dadosIndicadorRef.current?.tipoCadastroProposta?.id !==
                        formik.values?.tipoCadastroProposta?.id
                        ? stylesDiff.hasDiff
                        : ''
                }`}
            >
                <InputDropDown
                    ref={tipoCadastroPropostaRef}
                    formik={formik}
                    disabled={isView}
                    optionLabel="descTipoCadastroProposta"
                    valueIsCompleteObject
                    callbackSetList={tipoCadastroPropostaService.list.bind(
                        tipoCadastroPropostaService
                    )}
                    onChange={(ev) => {
                        const item = tipoCadastroPropostaRef.current?.lista.find(
                            (el) => el?.id === ev.value
                        );
                        formik.setFieldValue('tipoCadastroProposta', item);
                        formik.setFieldValue('concordaTermo', false);
                    }}
                />
            </InputField>
            <Fieldset
                className={`p-col-12 p-md-8 ${styles.fieldset} ${
                    idIndicador &&
                    dadosIndicadorRef.current?.concordaTermo !== formik.values?.concordaTermo
                        ? stylesDiff.hasFieldDiff
                        : ''
                }`}
                legend="Termo de Consentimento:"
            >
                <div className={styles.containerTermos}>
                    <div>
                        <InfoIcon
                            messageInfo={PageMessages.sei.propostaIndicador.inputs.concordaTermo}
                            uniqueClass={'concordaTermo'}
                        />
                    </div>
                    <div>{PageMessages.sei.propostaIndicador.termosConsentimento}</div>
                </div>
                <div>
                    <Checkbutton
                        formik={formik}
                        name="concordaTermo"
                        hasBollean
                        disabled={
                            isView ||
                            formik.values?.tipoCadastroProposta?.codgTipoCadProposta !== 'NOVO'
                        }
                        label={
                            inputsSerieHistoricaTopo.find(
                                (input) => input?.name === 'concordaTermo'
                            )?.label
                        }
                    />
                </div>
            </Fieldset>
        </form>
    );
    return (
        <BaseForm
            ref={ref}
            page={Pages.sei.propostaIndicador}
            initialValues={inputsSerieHistoricaTopo.filter((input) => input?.form?.use ?? false)}
            buscarOnLoad={false}
            redirectOnSave={false}
        >
            <Inputs />
        </BaseForm>
    );
}

export default forwardRef(FormTopo);
